













import {Component, Prop} from "vue-property-decorator";
import CommonBase from "@/components/CommonBase";

@Component
export default class ForegroundLocationReason extends CommonBase {
  @Prop({default: false})
  positionSettingsFixPossible!: boolean;

  @Prop({default: false})
  isIosSafari!: boolean;

  @Prop({default: null})
  iphoneWebResetPath!: string | null;
}
